import React, {Component} from "react";/*
    For Redux, need to import connect and action
    Redux connect is to access Redux
    Redux action to update the state of the form field
*/
import { connect } from "react-redux";
import { updateForm } from "../../store/actions/FormAction";
import Autosuggest from 'react-autosuggest';

import usbanks from "../views/BankingInfo/banks.json";

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = value => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0 ? [] : usbanks.filter(bnk =>
    bnk.name.toLowerCase().slice(0, inputLength) === inputValue
  );
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
    {suggestion.name}
  </div>
);

class DocTypeSelector extends Component {
  constructor() {
    super();

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      suggestions: []
    };
  }

  onChange = (event, { newValue }) => {
    this.props.updateForm("doctype", newValue);

    //need to check routing number if matches bank
    this.props.updateForm("doctypechecked", true);
  };

  // Autosuggest will call this function every time you need to update suggestions.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const { suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      id: "docs",
      name: "bank",
      className: "form-control",
      tabIndex:"2",
      placeholder: 'Start typing...',
      value: this.props.doctype,
      onChange: this.onChange
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}

const mapStateToProps = (state) => ({
    doctype: state.FormReducer.doctype,
    doctypechecked: state.FormReducer.doctypechecked
})

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value))
})

export default connect(mapStateToProps, mapDispatchToProps)(DocTypeSelector);



// WEBPACK FOOTER //
// ./src/components/partials/DocTypeSelector.js